<template>
  <div class="main">
    <div
      class="dropzone-container"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        type="file"
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept=".pdf,.jpg,.jpeg,.png"
      />
      <label for="fileInput" class="file-label">
        <div v-if="isDragging">Release to drop files here.</div>
        <div v-else>
          <b-img class="mb-2" :src="scannerImg" width="100" height="100" />
          <h4>Drag and Drop Scanned Images Here</h4>
        </div>
      </label>
    </div>
  </div>
</template>
<script>
import { BImg } from "bootstrap-vue";
import ScannerIllustration from "@/assets/images/illustration/scanner.png";

export default {
  components: {
    BImg,
  },

  data() {
    return {
      isDragging: false,
      files: [],
      loading: false,
      params: {
        form: {},
        path: "",
      },
      scannerImg: ScannerIllustration,
    };
  },
  props: [
    "getAttachments",
    "attachableId",
    "attachableType",
    "type",
    "patientCardId",
  ],
  methods: {
    submitClinicAttachment() {
      this.loading = true;
      let data = new FormData();
      this.createMode = true;
      data.append("attachment", this.$refs.file.files[0]);
      data.append("patient_card_id", this.patientCardId);

      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = data),
          (this.params.path = `/clinic-attachment`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getAttachments();
              this.loading = false;
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    onChange() {
      if (this.type === "CLINIC") {
        return this.submitClinicAttachment();
      }
      this.loading = true;
      let data = new FormData();
      this.createMode = true;
      data.append("attachment", this.$refs.file.files[0]);
      data.append("attachable_id", this.patientCardId ?? this.attachableId);
      data.append("attachable_type", this.attachableType);
      data.append("type", this.type);

      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = data),
          (this.params.path = `/attachment`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getAttachments();
              this.loading = false;
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
  },
};
</script>
<style>
.main {
  display: flex;
  flex-grow: 1;
  align-items: center;

  justify-content: center;
  text-align: center;
}

.dropzone-container {
  padding: 4rem;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}
</style>
